// extracted by mini-css-extract-plugin
export default {"spaceXXXL":"8rem","spaceXXL":"4rem","spaceXL":"3rem","spaceL":"2rem","spaceM":"1.5rem","spaceS":"1rem","spaceXS":".5rem","spaceXXS":".25rem","heading":"heading--bWqzu"};